import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PatientProfile } from './models/patient.model';
import { TreatmentRecommendation } from './models/treatment.model';
import { RecommendationService } from './recommendations.service';

@Component({
  selector: 'csi-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss']
})
export class RecommendationsComponent implements OnInit {
  @Input() patientProfile!: PatientProfile;
  @Output() useRecommendations = new EventEmitter<TreatmentRecommendation>();

  recommendations?: TreatmentRecommendation;
  suggestedTemplateKey = 'N/A';
  isLoading = false;
  error?: string;

  constructor(private recommendationService: RecommendationService) {}

  ngOnInit(): void {
    if (this.patientProfile) {
      this.generateRecommendations(this.patientProfile);
    }
  }

  generateRecommendations(profile: PatientProfile): void {
    this.isLoading = true;
    this.error = undefined;

    try {
      console.log('[RecommendationService] Generating for:', profile);
      this.recommendations = this.recommendationService.generateRecommendations(profile);
      this.suggestedTemplateKey =
        this.recommendations.baseTemplate && this.recommendations.baseTemplate.friendlyId
          ? this.recommendations.baseTemplate.friendlyId
          : 'N/A';
      console.log('[RecommendationsComponent] Recommendations received:', this.recommendations);
    } catch (err) {
      console.error(err);
      this.error = 'Failed to generate recommendations.';
      this.suggestedTemplateKey = 'N/A';
    } finally {
      this.isLoading = false;
    }
  }

  onRegenerate(): void {
    if (!this.patientProfile) return;
    this.generateRecommendations(this.patientProfile);
  }

  applyToMainRecommendations(): void {
    if (!this.recommendations) return;
    console.log('[RecommendationsComponent] Applying AI recommendations...');
    this.useRecommendations.emit(this.recommendations);
  }

  getTreatmentNames(treatments: any[] | undefined): string[] {
    if (!treatments) return [];
    return treatments.map(treatment =>
      typeof treatment === 'string'
        ? treatment
        : (treatment && treatment.name) ||
          (treatment && treatment.id) ||
          (treatment && treatment.title) ||
          'Unknown treatment'
    );
  }
}
